import { clinics } from "../components/constants";
export type HomeSection = {
  title: string;
  description?: string;
  image: string;
  routerName: string;
};

export enum EDocumentCategory {
  WEIGHT_DATA = "weight",
  NUTRITION = "nutrition",
  MOVEMENT = "movement",
  DIET = "diet",
}

export type TestQuestion = {
  id: string;
  statement: string;
  answers: Array<{
    statement: string;
    id: string;
  }>;
};

type TBaseDocument = {
  title: string;
  createdOn: number;
};

export type TWeightDocument = TBaseDocument & {
  category: EDocumentCategory.WEIGHT_DATA;
  weight: number;
  measurementDate: number;
};

type StandardDocument = TBaseDocument & {
  category:
    | EDocumentCategory.NUTRITION
    | EDocumentCategory.MOVEMENT
    | EDocumentCategory.DIET;
};

export type TDocument = TWeightDocument | StandardDocument;

export type SectionStepEnabled = {
  enabled: true;
  id: string;
  title: string;
  order: number;
  completedOn?: number;
  youtubeVideoId: string;
  questions: Array<TestQuestion>;
};

type SectionStepDisabled = {
  enabled: false;
  title: string;
  order: number;
};

export type SectionStep = SectionStepEnabled | SectionStepDisabled;

export type UserProgramSection = {
  title: string;
  coverUrl: string;
  steps: Array<SectionStep>;
  documentCategories: Array<EDocumentCategory>;
  documents: Array<TDocument>;
  handoutStepNumber?: number;
  handoutLink?: string;
  handoutStepPassed?: boolean;
};

export type TTypeformId = "oLfjZqYg";

export type UserProgram = {
  clinicName: string;
  clinicCode: string;
  clinicLogoUrl?: string;
  startDate: Date;
  endDate: Date;
  sections: Array<UserProgramSection>;
  userRole: "patient" | "clinic-dashboard";
  formsFilled: Array<TTypeformId>;
  user: {
    clinic?: string;
    firstName?: string;
    lastName?: string;
    email?: string;
    phone?: string;
    role?: string;
    _id?: string;
  };
};
